
import { PALETTE } from '../../../constants';
import { MediaQueryStyleSheet } from "react-native-responsive";

export default MediaQueryStyleSheet.create({
  root:
  {
    flexDirection: 'column',
    flex: '1',
    backgroundColor: PALETTE.duskBlue,
    padding: 18,
    marginBottom: 15
  },
  rootCustom:
  {
    flexDirection: 'column',
    flex: '1',
    backgroundColor:PALETTE.morningBlue,
    padding: 18,
    marginBottom: 15
  },
  reportsTable:{
    width:'100%'
  },
  tableRoot: {
    padding: 18
  },
  tableRootContent:{
    // backgroundColor:'#0e1b34',
  },
  reportName:{
    width:'45%',
    display:'flex-wrap',
    alignItems:'center'
  },
  iconStyle:{
    alignSelf:'flex-start'
  },
  portfolio:{
    width:'15%'
  },
  date: {
    width:'10%'

  },
  preview: {
    width:'5%',
    textAlign:'center'

  },
  download: {
    width:'8%',
    textAlign:'center'

  },
  checkbox:{
    width:'30px',
  },
  container: {
    flexDirection: 'row',
    display:'flex',
    justifyContent: 'space-between',
    alignItems:'center',
    width: '100%',

    // padding: '18px',

  },
  containerParent:{
    flexDirection: 'row',
    display:'flex',
    justifyContent: 'space-between',
    alignItems:'center',
    width: '100%',
    color: PALETTE.secondaryText

  },
  firstContainer: {
  flexDirection: 'row',
  flex:2,
  },
  
  icon:{
    width: '25px',
    height:'25px',
    color: '#fff'
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%'
  },
  otherRow: {
    width: '100%',
    display:'flex',
  }

});
